import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconRotate90Right20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconRotate90Right20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5 10.5v3H3.5a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1V8h-3A2.5 2.5 0 0 0 5 10.5M3.5 15H5v1.5A2.5 2.5 0 0 0 7.5 19h9a2.5 2.5 0 0 0 2.5-2.5v-6A2.5 2.5 0 0 0 16.5 8H12V3.5A2.5 2.5 0 0 0 9.5 1h-6A2.5 2.5 0 0 0 1 3.5v9A2.5 2.5 0 0 0 3.5 15m14-4.5a1 1 0 0 0-1-1h-9a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1zM15.579 1H13.5v1.5h2.079c1.017 0 1.921.784 1.921 1.75V6.5H19V4.25C19 2.455 17.468 1 15.579 1"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconRotate90Right20);
